module.exports = __webpack_public_path__ + "static/img/class-end@3x.ef9d9329.png";